import React from 'react';
import { Modal, ModalBody } from 'reactstrap';

export function CancelSubscriptionScheduleModal({ callback, open, onClose }) {
  const handleCancel = () => callback();

  return (
    <Modal
      isOpen={open}
      className="cancel-popup-content modal-dialog-centered mx-auto"
      modalClassName="calcel-popup"
      toggle={() => onClose()}
    >
      <div className="cancel-popup-header">
        <div className="title">
          Cancel scheduled plan update
          <i className="icon-close" onClick={() => onClose()} />
        </div>
      </div>
      <div className="gradient-divider" />
      <ModalBody>
        <div className="my-4">
          Do you want to cancel the scheduled plan update?
        </div>
        <button
          className="btn btn-danger pause-subscription-button btn-block mb-3"
          data-test="cancel-update-button"
          onClick={() => handleCancel()}
        >
          Cancel Update
        </button>
      </ModalBody>
    </Modal>
  );
}
